import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { userEditFun, userInfoFun } from '../../api/userAPI';
import DefaultUser from '../../assets/icons/trvto_avatar.svg';
import './account.css';
import Dialog from '../../components/dialogModal/dialogModal';
import { toast } from 'react-toastify';
import OTPInput from '../../components/otpinput/otpinput';
import emailValid from '../../utils/emailValid';
import errorHandle from '../../utils/errorHandle';
import handleChange from '../../utils/handleChange';
import { useTempOrg } from '../../context/TempOrgContext';
import { regOTPFun, verifyEmailOtp } from '../../api/userLoginAPI';

export default function Account() {
    const [userDetails, setUserDetails] = useState({
        emailId: '',
        emailOTP: ''
    });
    const [data, setData] = useState({});
    const [modal, setModal] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [otpError, setOtpError] = useState('');
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [response, setResponse] = useState(false);
    const { tempOrg } = useTempOrg();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setLoading(true); // ✅ start loading
                const res = await userInfoFun();
                setData(res?.data);
            } catch (error) {
                errorHandle(error);
            } finally {
                setLoading(false); // ✅ stop loading
            }
        };

        fetchUserData();
    }, [load]);

    const refresh = () => {
        setLoad(!load);
    };

    async function getSupOTP() {
        if (!emailValid(userDetails.emailId)) {
            setEmailError('Please enter a valid email address');
            return;
        }

        setEmailError('');
        setLoading(true);

        try {
            const res = await regOTPFun({ emailId: userDetails.emailId }, 'email');

            if (res?.status === 200) {
                setResponse(true); // or true
                <div style={{ position: 'relative', zIndex: 99999 }}>{toast.success('OTP sent to your email')}</div>;
            } else {
                toast.error('Failed to send OTP. Please try again.');
                console.log(res);
            }
        } catch (error) {
            console.log(error);
            errorHandle(error);
        } finally {
            setLoading(false);
        }
    }

    async function handleVerification() {
        if (userDetails.emailOTP.length <= 5) {
            setOtpError('Please enter the complete OTP');
            return;
        }
        setOtpError('');
        //Start loading animation
        setLoading(true);

        try {
            const emailVerify = await verifyEmailOtp(userDetails);
            if (emailVerify.status === 200) {
                const res = await userEditFun({ emailId: userDetails.emailId });
                if (res.status === 200) {
                    setModal(false);
                    toast.success('Email id added Successful');
                    refresh();
                }
            }
        } catch (error) {
            errorHandle(error);
            //End loading animation
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            response !== '200' ? getSupOTP() : handleVerification();
        }
    };

    return (
        <div className='account-container' style={{ marginTop: tempOrg?.id ? '80px' : '' }}>
            <div className='account-header'>
                <img className='account-user-pic' src={data?.profilePicture || DefaultUser} alt='trvto_User' />
                <h2>Welcome, {data?.name || 'User'}</h2>
                <p>Manage your account and explore your preferences</p>
            </div>

            <div className='account-info'>
                <div className='info-item'>
                    <strong>Contact Number :</strong> <span>{data?.phoneNumber || 'N/A'}</span>
                </div>
                <div className='info-item' onClick={() => setModal(true)}>
                    <strong>Email :</strong>
                    {data?.emailId ? (
                        <span>{data?.emailId || 'N/A'}</span>
                    ) : (
                        <span className='dialogActBtn emailButton submit'>Add email</span>
                    )}
                </div>
                <div className='info-item'>
                    <strong>Reward Coins :</strong> <span>{data?.rewards?.[0]?.count ?? 0}</span>
                </div>
                <div className='info-item'>
                    <strong>Cash :</strong> <span>{data?.rewards?.[1]?.count ?? 0}</span>
                </div>
            </div>

            <div className='account-actions'>
                <Link to='/my-booking' className='account-link'>
                    Your Bookings
                </Link>
                <Link to='/my-wishlist' className='account-link'>
                    Your Wishlist
                </Link>
            </div>
            {modal && (
                <Dialog openModal={modal} heading={'Add email'} loading={loading}>
                    <div>
                        <div>
                            <div className=''>
                                <div className=''>
                                    <input
                                        placeholder='Enter your email'
                                        name='emailId'
                                        onChange={(e) => handleChange(e, setUserDetails)}
                                        onKeyDown={handleKeyDown}
                                        value={userDetails.emailId}
                                        type='email'
                                        className='accountLoginInput'
                                    />
                                    {emailError && <span className='accountLoginError'>{emailError}</span>}
                                    {response && (
                                        <div className='accountInputDiv'>
                                            <p>Check your email for OTP</p>
                                            <label>OTP</label>
                                            <OTPInput
                                                length={6}
                                                setUserData={setUserDetails}
                                                keyName={'emailOTP'}
                                                handleKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    )}
                                    {response && otpError && <span className='accountLoginError'>{otpError}</span>}
                                </div>
                            </div>
                        </div>
                        <div className='alignCenter'>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setModal(false);
                                    setResponse(false);
                                }}
                            >
                                Cancel
                            </button>
                            {!response ? (
                                <button type='button' onClick={() => getSupOTP()} className='dialogActBtn submit'>
                                    Get Otp
                                </button>
                            ) : (
                                <button className='dialogActBtn submit' onClick={handleVerification}>
                                    Submit
                                </button>
                            )}
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
}
